module.exports = __webpack_public_path__ + "static/media/mobileBackground.eb953523.jpg";